import { render, staticRenderFns } from "./SelfMarriageCert.vue?vue&type=template&id=09f544f4&"
import script from "./SelfMarriageCert.vue?vue&type=script&lang=js&"
export * from "./SelfMarriageCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports